export async function verifyTokenValidity(token) {
  if (!token) return false;
  const res = await fetch(
    `${process.env.REACT_APP_API_V2}/connect/api/user/v2/accounts/info`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.status === 200;
}
